export default {"src":"/_next/static/media/training-confirm.ebd806b0.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};